import { defineMessages } from 'react-intl';

export const trialUpgradeRequestCallbackModalMessages = defineMessages({
  title: {
    id: 'clrgiH1IG8',
    defaultMessage: 'Request a call back',
    description: 'Title on the trial upgrade request callback modal',
  },
  descriptionPractice: {
    id: 'ATbcuNLRBC',
    defaultMessage:
      'Send a message and a Heidi expert will be in touch to talk about upgrading to Practice.',
    description:
      'Supporting copy on the trial upgrade request callback modal (Practice tier)',
  },
  descriptionClinician: {
    id: 'P4i2srnSs+',
    defaultMessage:
      'Send a message and a Heidi expert will be in touch to talk about upgrading to Clinician.',
    description:
      'Supporting copy on the trial upgrade request callback modal (Clinician tier)',
  },
  messageLabel: {
    id: '0bM2+MchNK',
    defaultMessage: 'Message',
    description:
      'Label for the message field on the trial upgrade request callback modal',
  },
  messagePlaceholderPractice: {
    id: 'wTDGMZrf0f',
    defaultMessage:
      "Hi, our Practice trial is ending and we'd like to keep using it. Could we upgrade the team?",
    description:
      'Placeholder hint text in the message field on the trial upgrade request callback modal (Practice tier)',
  },
  messagePlaceholderClinician: {
    id: 'XeRQ9yHMTJ',
    defaultMessage:
      "Hi, our Clinician trial is ending and we'd like to keep using it. Could we upgrade the team?",
    description:
      'Placeholder hint text in the message field on the trial upgrade request callback modal (Clinician tier)',
  },
  contactNumberLabel: {
    id: 'vInw+qosaH',
    defaultMessage: 'Contact number',
    description:
      'Label for the contact number field on the trial upgrade request callback modal',
  },
  contactNumberPlaceholder: {
    id: 'sgrsrmaNBs',
    defaultMessage: '9212 3456',
    description:
      'Placeholder for the contact number field on the trial upgrade request callback modal',
  },
  send: {
    id: '4SQJ0IV690',
    defaultMessage: 'Send',
    description: 'Primary submit button on the trial upgrade request callback modal',
  },
  cancel: {
    id: 'riCfdGJmS+',
    defaultMessage: 'Cancel',
    description: 'Dismiss button on the trial upgrade request callback modal',
  },
  back: {
    id: 'mPPOn1YXkk',
    defaultMessage: 'Back',
    description:
      'Back control on the trial upgrade request callback modal (closes without sending)',
  },
  requestSentSuccess: {
    id: 'xbbs+aFOYh',
    defaultMessage: 'Sent! We’ll be in touch',
    description: 'Success toast after the user submits a trial upgrade call back request',
  },
  requestSentTrialExtended: {
    id: 'GmvZj9ddQt',
    defaultMessage:
      'In the meantime, we’ve given you an extra 14 days on your trial so your workflow stays uninterrupted',
    description:
      'Success toast shown when the trial upgrade call back request also extended the user’s trial',
  },
  requestFailedTimeout: {
    id: 'kG3UHbmbYy',
    defaultMessage: 'Request timed out. Please try again.',
    description: 'Error toast when the trial upgrade call back request times out',
  },
  requestFailedGeneric: {
    id: 'vFhd/2+icq',
    defaultMessage: 'Something went wrong. Please try again.',
    description:
      'Error toast when the trial upgrade call back request fails for a non-timeout reason',
  },
  callbackRequestedCta: {
    id: 'A4HmDXFJ94',
    defaultMessage: 'Callback requested',
    description:
      'Disabled primary CTA label after the user has already submitted a trial upgrade callback request',
  },
});
